import React, { useState, useEffect } from "react";
import {
  Card,
  Row,
  Col,
  Typography,
  Input,
  Button,
  Select,
  Switch,
  Modal,
  Tooltip,
  Space,
  message,
  Grid,
  App,
  Drawer,
  Flex
} from "antd";
import {
  ArrowLeftOutlined,
  CopyOutlined,
  InfoCircleOutlined,
  PlusOutlined,
  QuestionCircleOutlined
} from "@ant-design/icons";
import swal from "sweetalert2";
import "./formstyle.css";
import { useNavigate } from "react-router-dom";

import { modifyAccessListBasedOnCompanyType } from "../../../lib/accessList";
import {
  getAccerssTypeApi,
  getTabsApi,
  saveRoleAccessApi,
  saveRoleApi,
  getAdminAccess,
   cloneRoleApi, 
  getUserRoleSubscriptionWiseListApi,
} from "../../../apiservice/setting";
import { FRONTEND_APP_URL } from "../../../environment";
import { getAccessType } from "../../../lib/functions";

const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

const UserRoleManage = ({ authInfo }) => {
  const navigate = useNavigate();
  const screens = useBreakpoint();
  let [access_type, access_type_set] = useState("");
  const { modal } = App.useApp();

  const Menus = [
    { label: "Dashboard", value: "dashboard" },
    { label: "Sales", value: "sales" },
    { label: "POS", value: "pos" },
    { label: "Quotation", value: "quotation" },
    { label: "Order", value: "order" },
    { label: "Service", value: "service" },
    { label: "Purchase", value: "purchase" },
    { label: "Manufacturing", value: "manufacturing" },
    { label: "Inventory", value: "inventory" },
    { label: "Accounts", value: "accounts" },
    { label: "HR&Payroll", value: "hrpayroll" },
    { label: "Reports", value: "reports" },
    { label: "CRM", value: "crm" },
    { label: "Delivery", value: "delivery" },
    { label: "Workflows", value: "workflows" },
    { label: "Settings", value: "settings" },
  ];

  const roleAccessOptions = [
    { label: "READ", value: "READ" },
    { label: "WRITE", value: "WRITE" },
  ];

  const [addUserModal, setAddUserModal] = useState(false);
  const [userCustomizeModal, setUserCustomizeModal] = useState(false);
  const [roles, setRoles] = useState([]);
  const [mainTabs, setMainTabs] = useState([]);
  const [tabs, setTabs] = useState({});
  const [selectTab, setSelectTab] = useState("");
  const [final, setFinal] = useState([]);
  const [currentRole, setCurrentRole] = useState({
    value: 0,
    label: "",
    isDefault: true,
  });
  const [addRoleName, setAddRoleName] = useState("");
  const [customizeTitle, setCustomizeTitle] = useState("");
  const [customizeTab, setCustomizeTab] = useState([]);
  const [checked_Items, setChecked_Items] = useState({});
  const [selectedRoles, setSelectedRoles] = useState({});
  const [initialChecked_Items, setInitialChecked_Items] = useState({});
  const [initialSelectedRoles, setInitialSelectedRoles] = useState({});
  const [adminAccess, setAdminAccess] = useState([]);
  const [adminTabAccess, setAdminTabAccess] = useState([]);
  const [keyTab, setKeyTab] = useState({});
  const [update, setUpdate] = useState(false);
  const [accessList, setAccessList] = useState([]);

  const [cloneModal, setCloneModal] = useState(false);
  const [helpOpen, setHelpOpen] = useState(false);
const [cloneRoleName, setCloneRoleName] = useState("");

const openCloneModal = () => {
  setCloneRoleName(`Copy of ${currentRole.label}`);
  setCloneModal(true);
};

const handleCloneRole = async () => {
  if (!cloneRoleName.trim()) {
    message.warning("Role name cannot be empty");
    return;
  }
  if (cloneRoleName.length > 60) {
    message.warning("Role name too long");
    return;
  }
  try {
    const res = await cloneRoleApi({
      institution_id: authInfo.id,
      role_name: cloneRoleName,
      clone_from_role_id: currentRole.value,
    });
    if (res.data.error) {
      swal({ title: res.data.msg, icon: "warning" });
      return;
    }
    message.success("Role cloned successfully!");
    setCloneModal(false);
    setCloneRoleName("");

    // ✅ Refresh roles then auto-select the cloned role
    await getUserRoleSubscriptionWiseListApi({
      id: authInfo.subscription_id,
      institution_id: authInfo.userInfo.pro_id,
    }).then((res) => {
      const subscription_base_data = res?.data?.subscriptionBaseData?.reduce(
        (acc, role) => {
          let newRoleName = role.role_name.includes("_")
            ? role.role_name.split("_").slice(2).join(" ")
            : role.role_name;
          if (newRoleName.toLowerCase() === "customer") return acc;
          acc.push({ ...role, role_name: newRoleName });
          return acc;
        }, []
      );
      const userAddedRoles = res.data.userAddedRoles;
      const mergedRoles = [...subscription_base_data, ...userAddedRoles];
      const data = mergedRoles.map((item) => ({
        value: item.id,
        label: item.role_name,
        isDefault: item.is_default === 1,
      }));
      setRoles(data);

      // ✅ Find and select the newly cloned role by name
      const cloned = data.find((r) => r.label === cloneRoleName);
      if (cloned) setCurrentRole(cloned);
    });

  } catch {
    message.error("Error cloning role");
  }
};

  /** ======================== API FUNCTIONS ======================== **/

  const getRoles = async () => {
    getUserRoleSubscriptionWiseListApi({
      id: authInfo.subscription_id,
      institution_id: authInfo.userInfo.pro_id,
    })
      .then((res) => {
        if (res === "Error: Request failed with status code 401") {
          sessionStorage.clear();
          window.location.href = `${FRONTEND_APP_URL}`;
        }
        const subscription_base_data = res?.data?.subscriptionBaseData?.reduce(
          (acc, role) => {
            let roleParts = role.role_name.split("_");
            // let newRoleName = role.role_name.includes("_")
            //   ? role.role_name.split("_").slice(2).join(" ")
            //   : role.role_name;
            let newRoleName = roleParts.length > 2
              ? roleParts.slice(2).join(" ")
              : role.role_name;
            if (newRoleName.toLowerCase() === "customer") return acc;
            acc.push({
              ...role,
              role_name: newRoleName,
            });
            return acc;
          },
          []
        );
        const userAddedRoles = res.data.userAddedRoles;
        const mergedRoles = [
          ...subscription_base_data,
          ...userAddedRoles.map((role) => ({ ...role })),
        ];
        const data = mergedRoles.map((item) => ({
          value: item.id,
          label: item.role_name,
          isDefault: item.is_default === 1,
        }));
        setRoles(data);
        setCurrentRole(data[0]);
      })
      .catch((err) => {
        swal({
          title: err.response?.data?.message || "Failed to load roles",
          icon: "warning",
        });
      });
  };

  const getTabs = async () => {
    await getTabsApi({
      institution_id: authInfo.id,
      role_id: currentRole.value,
    })
      .then((res) => setMainTabs(res.data))
      .catch((err) => {
        swal({
          title: err.response?.data?.message || "Failed to load tabs",
          icon: "warning",
        });
      });
  };

  const getAccessTyp = async () => {
    await getAccerssTypeApi({
      institution_id: authInfo.id,
      role_id: currentRole.value,
    })
      .then((res) => {
        const data = res.data;
        const initialData = data.map((item) => ({
          value: item.access,
          access_type: item.access_type,
          tab: item.tab,
        }));
        const initialSelectedRoles = {};
        const initialCheckedItems = {};
        initialData.forEach((item) => {
          initialCheckedItems[item.value] = true;
          initialSelectedRoles[item.value] = item.access_type;
        });
        setSelectedRoles(initialSelectedRoles);
        setChecked_Items(initialCheckedItems);
        setInitialSelectedRoles(initialSelectedRoles);
        setInitialChecked_Items(initialCheckedItems);
        // Seed final with existing data so editing one tab doesn't wipe others
        setFinal(initialData.map((item) => ({
          value: item.value,
          access: item.access_type,
          tab: item.tab,
        })));
        setUpdate(false);
      })
      .catch(() => {
        message.warning("Error loading access types");
      });
  };

  const getAdminAccessData = async () => {
    getAdminAccess()
      .then((res) => {
        const AdminAccess = res.data?.dataaccesslist?.map((i) => i.access);
        const AdminTabAccess = res.data?.dataTablist?.map((i) => i.tab);
        const tabKey = {};
        res.data?.roleAccessData?.forEach((i) => {
          tabKey[i.access] = i.tab;
        });
        setKeyTab(tabKey);
        setAdminAccess(AdminAccess);
        setAdminTabAccess(AdminTabAccess);
      })
      .catch(() => message.warning("Error fetching admin access"));
  };

  /** ======================== LOGIC ======================== **/

  useEffect(() => {
    const access = getAccessType("user_role_manage");
    access_type_set(access);
  }, []);


  useEffect(() => {
    const updateAccess = async () => {
      const updated = await modifyAccessListBasedOnCompanyType(authInfo);
      setAccessList(updated);
    };
    updateAccess();
  }, [authInfo]);

  useEffect(() => {
    getAdminAccessData();
    getRoles();
  }, []);

  useEffect(() => {
    if (currentRole?.value) {
      getTabs();
      getAccessTyp();
    }
  }, [currentRole]);

  useEffect(() => {
    const convertedArray = mainTabs.map((item) => item.tab).filter(Boolean);
    const initialChecked = {};
    Menus.forEach((item) => {
      initialChecked[item.value] = convertedArray.includes(item.value);
    });
    setTabs(initialChecked);
  }, [mainTabs]);

  const handleSwitchChange = (itemValue, checked) => {
    setTabs((prev) => ({ ...prev, [itemValue]: checked }));

      if (checked) {
    const menuItem = Menus.find((m) => m.value === itemValue);
    if (menuItem) {
      customizeSettings(menuItem);
    }
  }
  };

  const customizeSettings = (item) => {
    setUserCustomizeModal(true);
    setCustomizeTitle(item.label);
    setCustomizeTab(accessList[item.value] || []);
    setSelectTab(item.value);
  };

  const getOutputArray = () => {
    return customizeTab
      .filter((item) => checked_Items[item.value])
      .map((item) => ({
        value: item.value,
        access: selectedRoles[item.value] || "READ",
        tab: selectTab,
      }));
  };

  const getInitialArray = () => {
    return customizeTab
      .filter((item) => initialChecked_Items[item.value])
      .map((item) => ({
        value: item.value,
        access: initialSelectedRoles[item.value] || "READ",
      }));
  };

  const filterData = () => {
    const data = getOutputArray();
    const toRemove = getInitialArray();
    return data.filter(
      (item) =>
        !toRemove.some(
          (removeItem) =>
            removeItem.access === item.access && removeItem.value === item.value
        )
    );
  };

  const handleCustomSettingChange = () => {
    const currentTabItemValues = new Set(customizeTab.map((i) => i.value));

    // Reverse lookup: access key → tab, derived from accessList (covers legacy null-tab DB records)
    const accessToTab = {};
    Object.entries(accessList).forEach(([tab, items]) => {
      (items || []).forEach((item) => { accessToTab[item.value] = tab; });
    });

    // Re-assign tab for existing final rows — items in the current modal get selectTab,
    // others use their stored tab or fall back to keyTab / accessToTab to fix legacy nulls
    const rslt = final.filter((row) => checked_Items[row.value]).map((row) => ({
      ...row,
      tab: currentTabItemValues.has(row.value)
        ? selectTab
        : (row.tab || keyTab[row.value] || accessToTab[row.value]),
    }));

    for (const [key, value] of Object.entries(checked_Items)) {
      const exists = rslt.some((row) => row.value === key);
      if (!exists && value) {
        rslt.push({
          value: key,
          access: selectedRoles[key] || "READ",
          tab: currentTabItemValues.has(key)
            ? selectTab
            : (keyTab[key] || accessToTab[key]),
        });
      }
    }
    rslt.forEach((row) => {
      if (Object.prototype.hasOwnProperty.call(selectedRoles, row.value)) {
        row.access = selectedRoles[row.value];
      }
    });
    setFinal(rslt);
    setUpdate(true);
    setUserCustomizeModal(false);
  };

  const onTabCancel = async () => {
    setUpdate(false);
    setFinal([]);
    await getTabs();
    await getAccessTyp();
  };

  const onTabSave = async () => {
    try {
      const payload = {
        role_id: currentRole.value,
        institution_id: authInfo.id,
        data: final,
      };
      if (update) {
        const res = await saveRoleAccessApi(payload);
        if (res.status === 200) {
          modal.success({ title: "Role Access Added" });
          setUpdate(false);
          getTabs();
          getAccessTyp();
        }
      }
    } catch {
      message.error("Error saving role access");
    }
  };

  const saveRoles = async () => {
    if (!addRoleName.trim()) {
      message.warning("Role cannot be empty");
      return;
    }
    if (addRoleName.length > 60) {
      message.warning("Role Size Exceeded");
      return;
    }
    await saveRoleApi({
      institution_id: authInfo.id,
      role_name: addRoleName,
    })
      .then((res) => {
        if (res.data.error) {
          swal({ title: res.data.msg, icon: "warning" });
          return;
        }
        message.success("Role Added Successfully");
        getRoles();
        setAddUserModal(false);
        setAddRoleName("");
      })
      .catch(() => message.error("Error adding role"));
  };

  /** ======================== UI ======================== **/

  return (
    <Card
      style={{ margin: 24, padding: screens.xs ? 16 : 24, borderRadius: 12 }}
    >
 <Row 
  justify="space-between" 
  align="middle" 
  style={{ marginBottom: 16, flexWrap: "wrap", gap: "8px" }}
>
  <Space>
    <Button
      type="text"
      icon={<ArrowLeftOutlined />}
      onClick={() => navigate(-1)}
    />
    <Title level={4} style={{ margin: 0 }}>
      User Roles
    </Title>
  </Space>

 {access_type === "WRITE" && (
  <div style={{ 
    display: "flex", 
    gap: "8px", 
    flexWrap: "wrap", 
    justifyContent: "flex-end",
    width: screens.xs ? "100%" : "auto"
  }}>
    <Tooltip title="Help">
  <Button
    type="text"
    icon={<QuestionCircleOutlined style={{ fontSize: 18 }} />}
    onClick={() => setHelpOpen(true)}
  />
</Tooltip>
    <Button
      icon={<CopyOutlined />}
      onClick={openCloneModal}
      disabled={!currentRole?.value}
      style={{ flex: screens.xs ? 1 : "unset" }}
        data-testid="clone-role"
    >
      Clone Role
    </Button>
    <Button
      type="primary"
      icon={<PlusOutlined />}
      onClick={() => setAddUserModal(true)}
      style={{ flex: screens.xs ? 1 : "unset" }}
      data-testid="new-role"
    >
      New Role
    </Button>
  </div>
)}
</Row>

      <Row style={{ marginBottom: 16 }}>
        <Col xs={24} sm={8} md={6}>
          <Text strong>
            User Role{" "}
            <Tooltip title="Role access can be customized only for newly added role.">
              <InfoCircleOutlined style={{ color: "#1677ff" }} />
            </Tooltip>
          </Text>
          <Select
            style={{ width: "100%", marginTop: 6 }}
            options={roles}
            value={currentRole?.value}
            onChange={(val) => {
              const found = roles.find((r) => r.value === val);
              setCurrentRole(found);
            }}
            placeholder="Select Role"
            data-testid="select-role"
          />
        </Col>
      </Row>

      {Menus.map((item) => (
        <Row
          key={item.value}
          justify="space-between"
          align="middle"
          style={{
            borderBottom: "1px solid #f0f0f0",
            padding: "8px 0",
          }}
        >
          <Col>
            <Text>{item.label}</Text>
          </Col>
          <Col>
            <Space>
              <Switch
                checked={tabs[item.value]}
                disabled={currentRole?.isDefault}
                onChange={(checked) => handleSwitchChange(item.value, checked)}
              />
              <Button
                type="link"
                disabled={currentRole?.isDefault}
                onClick={() => customizeSettings(item)}
                data-testid="Customise-Settings"
              >
                Customise Settings
              </Button>
            </Space>
          </Col>
        </Row>
      ))}

      {access_type == "WRITE" && (
        <>
          {!currentRole?.isDefault && (
            <Space style={{ marginTop: 24 }}>
              <Button onClick={onTabCancel}>Cancel</Button>
              <Button
                type="primary"
                onClick={onTabSave}
                data-testid="role-save"
              >
                Save
              </Button>
            </Space>
          )}
        </>
      )}

      <Modal
  title={`Clone "${currentRole?.label}" Role`}
  open={cloneModal}
  footer={null}
  onCancel={() => { setCloneModal(false); setCloneRoleName(""); }}
  centered
>
  <label className="form-label">
    New Role Name<span style={{ color: "#ff4d4f" }}>*</span>
  </label>
  <Input
    placeholder="New Role Name"
    value={cloneRoleName}
    onChange={(e) => setCloneRoleName(e.target.value)}
      data-testid="clone-role-name"  
  />
  <div className="modal-buttons-container">
    <button
      className="erp-discard-button"
      onClick={() => { setCloneModal(false); setCloneRoleName(""); }}
    >
      Discard
    </button>
    <button
      className="erp-approve-button"
      onClick={handleCloneRole}
      data-testid="clone-role-save"   
    >
      Clone & Save
    </button>
  </div>
</Modal>

<Drawer
  title="User Role Management Help"
  open={helpOpen}
  onClose={() => setHelpOpen(false)}
  width={460}
  styles={{
          wrapper: {
            paddingTop: !screens.md ? "80px" : undefined
          }
        }}
>
  <div style={{ lineHeight: 1.8 }}>
    <h2
      style={{
        fontSize: 18,
        fontWeight: 600,
        marginBottom: 12,
        marginLeft:12
      }}
    >
      User Role Management
    </h2>

    <p style={{ color: "#555", marginBottom: 16, marginLeft:17 }}>
      This section helps manage ERP user roles, permissions,
      module access controls, and customizable user access settings.
    </p>

    <div
      style={{
        background: "#f5f5f5",
        padding: 14,
        borderRadius: 8,
        marginBottom: 16,
      }}
    >
      <strong>What You Can Do</strong>

      <ol style={{ paddingLeft: 20, marginTop: 10 }}>
        <li>Create new user roles</li>
        <li>Clone existing user roles with all permissions</li>
        <li>Enable or disable ERP module access</li>
        <li>Customize access permissions module-wise</li>
        <li>Assign READ or WRITE access levels</li>
        <li>Manage Dashboard, Sales, Inventory, CRM, HR, Accounts, Reports, and other modules</li>
        <li>Control feature visibility for different user roles</li>
        <li>Save customized role access configurations</li>
        <li>Manage operational access across ERP workflows</li>
      </ol>
    </div>

    <div
      style={{
        background: "#fafafa",
        border: "1px solid #eee",
        padding: 14,
        borderRadius: 8,
      }}
    >
      <strong>Important Notes</strong>

      <ul
        style={{
          paddingLeft: 18,
          marginTop: 10,
          color: "#666",
        }}
      >
        <li>Default system roles cannot be modified.</li>
        <li>WRITE access includes READ permissions automatically.</li>
        <li>Customized permissions affect user visibility throughout the ERP.</li>
        <li>Cloned roles duplicate existing permission structures.</li>
        <li>Changes apply immediately after saving role access.</li>
        <li>Only authorized users can manage user roles.</li>
        <li>Module access depends on company subscription availability.</li>
      </ul>
    </div>
  </div>
</Drawer>

      {/* Add Role Modal */}
      <Modal
        title="Add New User Role"
        open={addUserModal}
        footer={null}
        onCancel={() => {
          setAddUserModal(false);
          setAddRoleName("");
        }}
        centered
      >
        <label className="form-label">
          User Role Name<span style={{ color: "#ff4d4f" }}>*</span>
        </label>
        <Input
          placeholder="User Role Name"
          value={addRoleName}
          onChange={(e) => setAddRoleName(e.target.value)}
          data-testid="user-role-name"
        />
        <div className="modal-buttons-container">
          <button
            className="erp-discard-button"
            onClick={() => {
              setAddUserModal(false);
              setAddRoleName("");
            }}
          >
            Discard
          </button>
          {access_type == "WRITE" && (
            <>
              <button
                data-testid="add-user-role"
                className="erp-approve-button"
                onClick={saveRoles}
              >
                Add User Role
              </button>
            </>
          )}
        </div>
      </Modal>

      {/* Customise Settings Modal */}
  <Modal
  title={`Customise ${customizeTitle}`}
  open={userCustomizeModal}
  onCancel={handleCustomSettingChange}
  centered
  footer={
    <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
      <Button onClick={() => setUserCustomizeModal(false)}>Cancel</Button>
      <Button type="primary" onClick={handleCustomSettingChange}>
        Save
      </Button>
    </div>
  }
>
  {customizeTab.map((item) => (
    <Row
      key={item.value}
      justify="space-between"
      align="middle"
      style={{ marginBottom: 10 }}
    >
      <Col>
        <Space>
          <input
            type="checkbox"
            checked={!!checked_Items[item.value]}
            onChange={() =>
              setChecked_Items((prev) => ({
                ...prev,
                [item.value]: !prev[item.value],
              }))
            }
          />
          <Text>{item.label}</Text>
        </Space>
      </Col>
      <Col>
        <Select
          style={{ width: 100 }}
          options={roleAccessOptions}
          value={selectedRoles[item.value] || "READ"}
          onChange={(val) =>
            setSelectedRoles((prev) => ({
              ...prev,
              [item.value]: val,
            }))
          }
        />
      </Col>
    </Row>
  ))}
</Modal>
    </Card>
  );
};

export default UserRoleManage;
